<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
    <BooleanSelectField name="hasTowHitch" :label="t('towHitch')" />

    <InputField
      v-if="hasTowHitch"
      name="brakedTowingCapacityInKg"
      :label="t('brakedTowingCapacity')"
      type="number"
      :min="0"
      :max-fraction-digits="0"
      empty-value-to="null"
      adornment="kg"
    />

    <InputField
      v-if="hasTowHitch"
      name="unbrakedTowingCapacityInKg"
      :label="t('unbrakedTowingCapacity')"
      type="number"
      :min="0"
      :max-fraction-digits="0"
      empty-value-to="null"
      adornment="kg"
    />
  </div>
</template>

<script lang="ts" setup>
import BooleanSelectField from '@/components/BooleanSelectField.vue';
import InputField from '@/components/InputField.vue';
import { useField, useFormContext } from 'vee-validate';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { value: hasTowHitch } = useField<boolean>('hasTowHitch');
const { setFieldValue } = useFormContext();

watch(hasTowHitch, (value) => {
  if (!value) {
    setFieldValue('brakedTowingCapacityInKg', null);
    setFieldValue('unbrakedTowingCapacityInKg', null);
  }
});
</script>

<i18n lang="json">
{
  "en": {
    "towHitch": "Tow hitch",
    "brakedTowingCapacity": "Braked towing capacity in kg",
    "unbrakedTowingCapacity": "Unbraked towing capacity in kg"
  },
  "de": {
    "towHitch": "Anhängerkupplung",
    "brakedTowingCapacity": "Anhängelast gebremst in kg",
    "unbrakedTowingCapacity": "Anhängelast ungebremst in kg"
  },
  "es": {
    "towHitch": "Enganche de remolque",
    "brakedTowingCapacity": "Masa remolcable frenada en kg",
    "unbrakedTowingCapacity": "Masa remolcable no frenada en kg"
  }
}
</i18n>
